<template>
  <div>
    <table class="min-w-full bg-white">
      <thead>
        <tr>
          <th class="px-4 py-2 border">Datum</th>
          <th class="px-4 py-2 border">Korisnik</th>
          <th class="px-4 py-2 border">Datum unosa</th>
          <th class="px-4 py-2 border">Napomena</th>
          <th class="px-4 py-2 border">Fotografije</th>
          <th class="px-4 py-2 border">Video</th>
          <th class="px-4 py-2 border">Detalji</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="wh in workHours" :key="wh.id">
          <td class="px-4 py-2 border">{{ wh.date }}</td>
          <td class="px-4 py-2 border">{{ wh.user ? wh.user.full_name : '-' }}</td>
          <td class="px-4 py-2 border">{{ formatDate(wh.created_at) }}</td>
          <td class="px-4 py-2 border">{{ wh.remark }}</td>
          <td class="px-4 py-2 border text-center">
            <span v-if="wh.media && wh.media.some(m => m.custom_properties && m.custom_properties.type === 'photo')" class="text-green-600 font-bold">Da</span>
            <span v-else class="text-gray-400">Ne</span>
          </td>
          <td class="px-4 py-2 border text-center">
            <img
              v-if="wh.media && wh.media.some(m => m.custom_properties && m.custom_properties.type === 'video')"
              src="/svg/video.svg"
              alt="video"
              style="width: 18px; height: 18px; opacity: 0.8;"
            />
          </td>
          <td class="px-4 py-2 border text-center">
            <button @click="showWorkHourDetails(wh)" class="btn btn-sm btn-primary">Detalji</button>
          </td>
        </tr>
        <tr v-if="!workHours.length">
          <td colspan="7" class="text-center py-4">Nema radnih sati za ovaj projekt.</td>
        </tr>
      </tbody>
    </table>
    <work-hour-details-modal
      :visible="modalOpen"
      :work-hour="selectedWorkHour"
      @close="closeModal"
    />
  </div>
</template>

<script>
import WorkHourDetailsModal from './WorkHourDetailsModal.vue';

export default {
  name: 'WorkHoursTable',
  components: {
    WorkHourDetailsModal
  },
  props: {
    workHours: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      modalOpen: false,
      selectedWorkHour: null
    };
  },
  methods: {
    showWorkHourDetails(wh) {
      this.selectedWorkHour = wh;
      this.modalOpen = true;
    },
    closeModal() {
      this.modalOpen = false;
      this.selectedWorkHour = null;
    },
    formatDate(date) {
      if (!date) return '';
      return window.moment
        ? window.moment(date).format('DD-MM-YYYY HH:mm:ss')
        : date;
    }
  }
};
</script>
